export default __webpack_public_path__ + "static/media/14KYCDetailsTataNeu2.f6779e28.png";